export default "__VITE_ASSET__DcpYsNV1__"